import type { ShiftRecord } from '@libs/data-access/queries'
import moment from 'moment'
import { Shift } from 'snap-redux/modules/shifts'

type Params = {
  userContractId?: number
  weeklyscheduleId: number
  defaultMeal: boolean
  date?: Date | string
}

/**
 * @deprecated look I know but please don't use it
 */
export const getDefaultShiftModelLegacy = ({
  userContractId,
  weeklyscheduleId,
  defaultMeal,
  date = new Date()
}: Params): ShiftRecord => {
  return new Shift({
    weeklyschedule_id: weeklyscheduleId,
    user_contract_id: userContractId,
    starts_at: moment(date).format(),
    ends_at: moment(date).format(),
    meal: defaultMeal
  }) as unknown as ShiftRecord
}
